import { Toast } from "primereact/toast";
import { useRef, useState } from "react";
import { IIndustryMast } from "../../models/IndustryMast";
import { EmptyIndustry } from "./EmptyIndustry";
import { Form } from "./Form";
import { Table } from "./Table";
import { IPermissionProps } from "../../models/Login";

export interface IModel {
    open: boolean,
    singleData: IIndustryMast
}

export const IndustryMast = (permissions: IPermissionProps) => {

    const [modal, setModal] = useState({ singleData: EmptyIndustry, open: false } as IModel);
    const [reload, setReload] = useState(false);
    const toast = useRef<any>(null);

    const hideDialog = () => {
        setModal({ singleData: EmptyIndustry, open: false })
    };

    return (
        <>
            <Table permissions={permissions} setModal={setModal} toast={toast} reload={reload}></Table>
            <Form singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload}></Form>

            <Toast ref={toast} />
        </>
    );
}
